import firebase from "./../Firebase";
import { ISignInProps } from "./../types/Types";
import { SignInStyle } from "./../styles/SignInStyle";
import { useHistory } from "react-router-dom";

const SignIn: React.FC<ISignInProps> = ({ auth }) => {
  const history = useHistory();

  async function SignInWithGoogle() {
    const provider = new firebase.auth.GoogleAuthProvider();
    await auth.signInWithPopup(provider);
    history.push("/");
  }

  return (
    <SignInStyle>
      <div className="login-area">
        <p> Please sign up to continue the chat 💬</p>
        <button onClick={SignInWithGoogle}>Sign in with Google</button>
      </div>
    </SignInStyle>
  );
};

export default SignIn;
